<template lang='pug'>
  i.svg-icon.svg-icon-setting
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M84.936,41.976l-6.15-0.782c-0.507-1.56-1.132-3.064-1.861-4.495l3.798-4.89 c1.537-1.979,1.357-4.772-0.399-6.473l-5.151-5.152c-1.718-1.772-4.511-1.95-6.493-0.415l-4.884,3.797 c-1.429-0.729-2.934-1.354-4.497-1.86l-0.782-6.14c-0.294-2.463-2.384-4.318-4.86-4.318h-7.327c-2.477,0-4.567,1.855-4.86,4.308 l-0.782,6.15c-1.563,0.506-3.068,1.128-4.498,1.86l-4.886-3.797c-1.976-1.535-4.77-1.357-6.473,0.399l-5.152,5.148 c-1.773,1.721-1.953,4.514-0.416,6.496l3.798,4.886c-0.732,1.43-1.354,2.935-1.861,4.495l-6.14,0.782 c-2.463,0.294-4.318,2.384-4.318,4.861v7.326c0,2.477,1.854,4.567,4.308,4.86l6.15,0.782c0.507,1.561,1.132,3.065,1.861,4.495 l-3.798,4.89c-1.537,1.979-1.357,4.771,0.399,6.473l5.152,5.152c1.72,1.77,4.511,1.946,6.493,0.412l4.886-3.798 c1.43,0.732,2.935,1.357,4.495,1.861l0.782,6.137c0.293,2.47,2.384,4.324,4.86,4.324h7.327c2.477,0,4.566-1.854,4.86-4.308 l0.782-6.15c1.56-0.507,3.064-1.132,4.494-1.86l4.891,3.797c1.979,1.537,4.771,1.357,6.473-0.398l5.152-5.152 c1.772-1.72,1.952-4.511,0.415-6.493l-3.797-4.886c0.731-1.43,1.356-2.935,1.86-4.495l6.136-0.782 c2.464-0.293,4.318-2.384,4.318-4.86v-7.326C89.243,44.36,87.389,42.27,84.936,41.976L84.936,41.976z M49.991,66.854 c-9.019,0-16.355-7.336-16.355-16.354s7.337-16.354,16.355-16.354S66.346,41.481,66.346,50.5S59.01,66.854,49.991,66.854 L49.991,66.854z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
